import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

export const HeroContainer = styled.div`
  position: relative;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-height: 520px;
  aspect-ratio: 16 / 9;

  ${breakpoints.xl} {
    center: center;
    max-height: 520px;
    justify-content: center;
    align-items: center;
  }

  img {
    height: 100%;
    flex-shrink: 0;
    object-fit: cover;
    width: 100%;
    margin-bottom: -10px;
  }
`;

export const HeroPresentation = styled.a`
  height: 100%;
  width: 100%;
  max-height: 520px;
  cursor: pointer;
  display: block;
  color: ${({ theme }) => theme.base.white};
  &:focus {
    border: 2px solid ${({ theme }) => theme.base.darkBlue};
  }
`;

export const HeroPresentationWithoutUrl = styled.div`
  height: 100%;
  width: 100%;
  z-index: 0;
`;

export const HeroContent = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 36px;
  margin: 0 auto;
  padding: 0 20px;
  z-index: 2;

  ${breakpoints.md} {
    padding: 0 40px;
  }

  ${breakpoints.xl} {
    bottom: 48px;
    max-width: 1360px;
  }
`;

export const HeroTitle = styled.div`
  color: ${({ theme }) => theme.base.white};
  font-weight: 700;
  line-height: 1.5rem;
  font-size: 1.125rem;
  margin-bottom: 8px;

  ${breakpoints.lg} {
    line-height: 2.25rem;
    font-size: 1.75rem;
    margin-bottom: 16px;
  }
`;

export const HeroCTA = styled.p`
  color: ${({ theme }) => theme.base.white};
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.25rem;
  text-decoration: underline;

  ${breakpoints.lg} {
    font-size: 1.25rem;
    line-height: 1.5rem;
  }
`;
